import { getTranslate } from 'react-localize-redux';
import { connect, Dispatch } from 'react-redux';

import { paymentActions } from '../../../weborder/redux';
import { AddCreditCardDialog as AddCreditCardDialogComponent } from './AddCreditCardDialog';

export const mapStateToProps = (state: WebOrder.State) => {
  return {
    translate: getTranslate(state.locale),
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<WebOrder.State>) => {
  return {
    creditCardPaymentAdded: (
      props: paymentActions.CreditCardPaymentAddedProps,
    ) => {
      dispatch(paymentActions.creditCardPaymentAdded(props));
    },
    cancelAddCardBridge: () => {
      dispatch(paymentActions.cancelAddBridge());
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddCreditCardDialogComponent);
